import { AdspertPlanType, InvoiceCurrency, SubscriptionInvoicePeriod } from '@app/core/models/customer.models';

export class GetCustomerSubscription {
  static type = '[Customer Subscription] Get';
}

export class GetCustomerSubscriptionConstraints {
  static type = '[Customer Subscription] Get constraints';
}

export class PreviewCustomerSubscription {
  static type = '[Customer Subscription] Preview';

  constructor(readonly currency?: InvoiceCurrency) {}
}

export class StartCustomerSubscription {
  static type = '[Customer Subscription] Start';

  constructor(
    readonly type: AdspertPlanType = AdspertPlanType.Essential,
    readonly currency?: InvoiceCurrency,
    readonly period: SubscriptionInvoicePeriod = SubscriptionInvoicePeriod.Monthly,
  ) {}
}

export class CancelCustomerSubscription {
  static type = '[Customer Subscription] Cancel';

  constructor(readonly endDate: Date) {}
}

export class DeleteCustomerSubscription {
  static type = '[Customer Subscription] Delete';
}

export class RestartCustomerSubscription {
  static type = '[Customer Subscription] Restart';
}
